// extracted by mini-css-extract-plugin
export default {"section":"BudgetSection_section__sP39D","amount":"BudgetSection_amount__tBseA","description":"BudgetSection_description__6w5lU"};